import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
import { weaveStorageUtil as storageUtil } from '../../services/storageUtil';
import { loadBuildFulfilled } from './weaveLoadSlice';

const makeBuild = (name: string, state: RootState) => {
  const trainer = state.weaveTrainer;
  return {
    name,
    date: new Date().toISOString(),
    intl: trainer.intl,
    rank: trainer.rank,
    weaves: trainer.weaves
      .filter(x => x.percentTarget)
      .map(x => ({ id: x.id, percentTarget: x.percentTarget }))
  };
}

export const saveBuild = (name: string): AppThunk => (dispatch, getState) => {
  const build = makeBuild(name, getState());
  storageUtil.saveBuild(name, build);
  dispatch(slice.actions.saveBuildFulfilled(build));
};

const initialState: WeaveSaveState = {
  visible: false,
  name: ''
};

export interface WeaveSaveState {
  visible: boolean;
  name: string;
}

export const slice = createSlice({
  name: 'weaveSave',
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state) => {
      state.visible = false;
    },
    saveBuildFulfilled: (state, action: PayloadAction<any>) => {
      state.name = action.payload.name;
      state.visible = false;
    }
  },
  extraReducers: builder => {
    builder.addCase(loadBuildFulfilled, (state, action) => {
      state.name = action.payload.name;
    });
  }
});

export default slice.reducer;
export const { show, hide, saveBuildFulfilled } = slice.actions;
